/* unplugin-vue-components disabled */import { render } from "./LoginView.vue?vue&type=template&id=ba8c9956&scoped=true"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"

import "./LoginView.vue?vue&type=style&index=0&id=ba8c9956&lang=scss&scoped=true"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba8c9956"]])

export default __exports__